import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@app/shared/ui/atoms/Common';
import { CarouselDots } from '@app/shared/ui/molecules/Common';
import { cn } from '@app/shared/utils/common';

interface CarouselFooterProps {
  slidesCount: number;
  currentSlideIndex: number;
  onPrev: () => void;
  canScrollPrev: boolean;
  onNext: () => void;
  canScrollNext: boolean;
}

export function CarouselFooter({
  slidesCount,
  currentSlideIndex,
  onPrev,
  canScrollPrev,
  onNext,
  canScrollNext,
}: CarouselFooterProps) {
  return (
    <footer
      className="flex items-center justify-center gap-5 bg-footer py-3 max-w-[480px] fixed w-full z-100"
      style={{
        height: 'calc(40px + var(--tg-safe-area-inset-bottom, 0px))',
        marginBottom: 'calc(-1 * var(--tg-safe-area-inset-bottom, 0px))',
        bottom: 'var(--tg-safe-area-inset-bottom, 0px)',
      }}
    >
      <Button
        variant="custom"
        className={cn('h-fit', !canScrollPrev && 'opacity-0')}
        onClick={onPrev}
        disabled={!canScrollPrev}
      >
        <ChevronLeft className="size-8 text-foreground" />
      </Button>
      <CarouselDots
        carouselLength={slidesCount}
        currentIndex={currentSlideIndex}
        colorMode="white"
      />
      <Button
        variant="custom"
        className={cn('h-fit', !canScrollNext && 'opacity-0')}
        onClick={onNext}
        disabled={!canScrollNext}
      >
        <ChevronRight className="size-8 text-foreground" />
      </Button>
    </footer>
  );
}
